import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

import { UserService, CommonService, DoctorService } from '../../../services/index';

@Component({
	selector: 'add-edit-doctor-user-window',
	templateUrl: './addEditDoctorUser.component.html'
})
export class AddEditDoctorUserComponent implements OnInit {
	public title: string;
	public mode: string;
	public userdata: any = {};
	branchList: any[] = [];
    allBranchList: any[] = [];
	isLoading: boolean = false;
	branchCtrl: FormControl;
	@Output() userListLoadEvent = new EventEmitter();

	doctorList: any[] = [];
	doctorlistCtrl: FormControl;
    filteredDoctorList: Observable<any[]>;

	// Excel upload properties
	@ViewChild('fileUpload') fileUpload;
	isExcelUpload: boolean = false;
	excelData: any;
	rawFile: File = null;
	rawFileName: string = '';
	doctorUserList = [];

	constructor(public store: Store<fromRootStore.State>, private userService: UserService, public commonService: CommonService, private doctorService: DoctorService, public bsModalRef: BsModalRef, public toasterService: ToasterService) {
		//FOR AUTO COMPLETE VALIDATION --- BRANCH MODEL
        function hasValidBranch(input: FormControl) {
            let brandModelID = input.value, retVal = null;
            if (brandModelID == "") {
                retVal = { inValidBranch: true };
            }
            if (brandModelID && typeof brandModelID === 'string') {
                retVal = { inValidBranch: true };
            }
            return retVal;
        }
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);

		// FOR DOCTOR AUTOCOMPLETE VALIDATION
        this.doctorlistCtrl = new FormControl(null, [
            Validators.required
        ]);

        this.filteredDoctorList = this.doctorlistCtrl.valueChanges
            .startWith(null)
            .map(name => (name && typeof name === 'string') ? this.filterDoctorList(name) : this.doctorList.slice());
	}

	ngOnInit(): void {
		let that = this;
		// Set default usertype to Doctor
		if (!this.userdata.usertype) {
			this.userdata.usertype = 'Doctor';
		}
		// Set default doctor_assistant to No
		if (!this.userdata.doctor_assistant) {
			this.userdata.doctor_assistant = 'No';
		}

		//TO LOAD BRANCH COMBO
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            that.branchList = _.filter(res.data, function(obj) { return obj['is_crm_branch'] == 'Yes' });
            that.allBranchList = that.branchList;
        });
		this.loadDoctorList();

		setTimeout(() => {
		    $('#username').focus();
		}, 100);
	}

	// FOR FILTER DOCTOR LIST
    filterDoctorList(name: string) {
        name = _.escapeRegExp(name);
        return this.doctorList.filter(doc => (new RegExp(name, 'gi').test(doc.name)));
    }

	onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
    displayFn(branchID: number) {
        if (branchID && this.branchList.length > 0) {
            let fitem = _.find(this.branchList, { 'branch_id': branchID });
            return fitem['branch_name'];
        }
        return '';
    }

	displayDoctor(doctor_id: number) {
		if (doctor_id && this.doctorList.length > 0) {
            let fitem = _.find(this.doctorList, { 'doctor_id': doctor_id });
            return fitem['name'];
        }
        return '';
    }

	loadDoctorList() {
        let that = this;
        this.doctorService
            .getDoctorList({})
            .then(function (res: any) {
                that.doctorList = res['data'];
                if (that.userdata['doctor_id']) {
                    that.doctorList.unshift({doctor_id: that.userdata['doctor_id'], name: that.userdata['doctorname']});
                    that.doctorlistCtrl.setValue(that.userdata['doctor_id']);
                }
            });
    }

	onSaveDoctorUser(): void {
		if (this.isExcelUpload) {
			// Excel upload
			this.saveExcelFile();
		} else {
			// Manual entry
			this.saveManualEntry();
		}
	}

	saveManualEntry(): void {
		let that = this;
		// Ensure usertype is always Doctor
		this.userdata.usertype = 'Doctor';

		this.userService
			.addUpdateDoctorUser(this.userdata)
			.then(function(res: any) {
				that.isLoading = false;
				if (res.success){
					swal('SUCCESS', res.message, 'success');
					that.bsModalRef.hide();
					that.userListLoadEvent.emit();
				}else{
					var toast = {
				      type: 'error',
				      title: 'ERROR',
				      body: res.message
				    };
				    that.toasterService.pop(toast);
				}
			});
	}

	// Excel Upload Methods
	onUploadModeChange(): void {
		if (this.isExcelUpload) {
			// Clear any existing excel data when switching to upload mode
			this.clearExcelData();
		}
	}

	downloadSampleFile() {
		const todayDate = moment().format('DD-MM-YYYY');

		// Get actual branch and doctor names from loaded data
		const sampleBranchName = (this.branchList && this.branchList.length > 0) ? this.branchList[0].branch_name : 'Sample Branch';
		const sampleDoctorName = (this.doctorList && this.doctorList.length > 0) ? this.doctorList[0].name : 'Dr. Sample Doctor';

		const ws = XLSX.utils.aoa_to_sheet([
			['USERNAME', 'PASSWORD', 'FULL NAME', 'MOBILE', 'EMAIL', 'ADDRESS', 'STATUS', 'BRANCH NAME', 'DOCTOR NAME', 'DOCTOR ASSISTANT'],
			['sample.user', 'password123', 'Dr. John Smith', '9876543210', 'john.smith@example.com', '123 Sample Street, City', 'Active', sampleBranchName, sampleDoctorName, 'No']
		]);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
		const fileName = 'Doctor_User_Upload_Sample_' + moment().format('DD-MM-YYYY_HH-mm') + '.xlsx';
		XLSX.writeFile(wb, fileName);
	}

	openFileWindow() {
		this.fileUpload.nativeElement.click();
	}

	uploadFile(sheet) {
		let workBook = null;
		let jsonData = null;
		const reader = new FileReader();

		if ((sheet.target.files.length == 0) || (sheet.target.files.length < 0)) {
			return;
		}

		const file = sheet.target.files[0];
		this.rawFile = file;

		reader.onload = (event) => {
			const data = reader.result;
			workBook = XLSX.read(data, { type: 'binary', cellDates: true });
			jsonData = workBook.SheetNames.reduce((initial, name) => {
				const sheet = workBook.Sheets[name];
				initial[name] = XLSX.utils.sheet_to_json(sheet);
				return initial;
			}, {});

			if (Object.keys(jsonData).length == 1) {
				this.excelData = JSON.stringify(jsonData);
				this.doctorUserList = jsonData.Sheet1;
				this.rawFileName = file.name;

				// Validate excel data
				this.validateExcelData();
			} else {
				this.clearExcelData();
				sheet.srcElement.value = null;
				swal({
					title: 'ERROR',
					text: 'Please upload a file with only one sheet',
					type: 'error'
				});
			}
		};

		reader.readAsBinaryString(file);
		this.fileUpload.nativeElement.value = '';
	}

	validateExcelData() {
		const requiredColumns = ['USERNAME', 'PASSWORD', 'FULL NAME', 'MOBILE', 'STATUS', 'BRANCH NAME', 'DOCTOR NAME', 'DOCTOR ASSISTANT'];
		const errors = [];

		if (this.doctorUserList.length === 0) {
			errors.push('Excel file is empty');
			return;
		}

		// Check if all required columns exist
		const firstRow = this.doctorUserList[0];
		for (let col of requiredColumns) {
			if (!(col in firstRow)) {
				errors.push(`Missing required column: ${col}`);
			}
		}

		// Validate each row
		for (let i = 0; i < this.doctorUserList.length; i++) {
			const row = this.doctorUserList[i];
			const rowNum = i + 2; // Excel row number (1-indexed + header)

			if (!row.USERNAME || row.USERNAME.toString().trim() === '') {
				errors.push(`Row ${rowNum}: Username is required`);
			}
			if (!row.PASSWORD || row.PASSWORD.toString().trim() === '') {
				errors.push(`Row ${rowNum}: Password is required`);
			}
			if (!row['FULL NAME'] || row['FULL NAME'].toString().trim() === '') {
				errors.push(`Row ${rowNum}: Full Name is required`);
			}
			if (!row.MOBILE || row.MOBILE.toString().trim() === '') {
				errors.push(`Row ${rowNum}: Mobile is required`);
			} else if (!/^\d{10}$/.test(row.MOBILE.toString().trim())) {
				errors.push(`Row ${rowNum}: Mobile must be 10 digits`);
			}
			if (!row.STATUS || !['Active', 'InActive'].includes(row.STATUS)) {
				errors.push(`Row ${rowNum}: Status must be Active or InActive`);
			}
			if (!row['BRANCH NAME'] || row['BRANCH NAME'].toString().trim() === '') {
				errors.push(`Row ${rowNum}: Branch Name is required`);
			}
			if (!row['DOCTOR NAME'] || row['DOCTOR NAME'].toString().trim() === '') {
				errors.push(`Row ${rowNum}: Doctor Name is required`);
			}
			if (!row['DOCTOR ASSISTANT'] || !['Yes', 'No'].includes(row['DOCTOR ASSISTANT'])) {
				errors.push(`Row ${rowNum}: Doctor Assistant must be Yes or No`);
			}
		}

		if (errors.length > 0) {
			swal({
				title: 'Validation Errors',
				html: this.buildErrorHtml(errors),
				type: 'error'
			});
			this.clearExcelData();
		}
	}

	buildErrorHtml(errors: string[]): string {
		let html = `<div style="max-height:300px;overflow-y:auto;text-align:left;border:1px solid #ddd;border-radius:4px;padding:6px 10px;">`;
		errors.forEach((err, i) => {
			html += `<div style="padding:5px 0;border-bottom:1px solid #eee;color:#dc3545;font-size:14px;">${i + 1}. ${err}</div>`;
		});
		html += `</div>`;
		return html;
	}

	clearExcelData() {
		this.excelData = '';
		this.rawFile = null;
		this.rawFileName = '';
		this.doctorUserList = [];
	}

	saveExcelFile() {
		if (!this.excelData || this.doctorUserList.length === 0) {
			swal({
				title: 'ERROR',
				text: 'Please upload an Excel file first',
				type: 'error'
			});
			return;
		}

		this.isLoading = true;
		const that = this;
		const params = {
			data: this.excelData,
			branchList: JSON.stringify(this.branchList),
			doctorList: JSON.stringify(this.doctorList)
		};

		this.userService
			.uploadDoctorUsers(params)
			.then(function (res: any) {
				that.isLoading = false;
				if (res.success) {
					that.clearExcelData();
					swal({
						title: 'Success',
						html: that.buildResultHtml(res.message, res.errors),
						type: 'success'
					});
					that.bsModalRef.hide();
					that.userListLoadEvent.emit();
				} else {
					swal({
						title: 'ERROR',
						html: that.buildResultHtml(res.message, res.errors),
						type: 'error'
					});
				}
			}).catch(() => {
				that.isLoading = false;
				swal({
					title: 'ERROR',
					text: 'An error occurred while uploading',
					type: 'error'
				});
			});
	}

	buildResultHtml(message: string, errors: string[]): string {
		let html = `<p style="margin-bottom:8px;">${message}</p>`;
		if (errors && errors.length > 0) {
			html += `<div style="max-height:300px;overflow-y:auto;text-align:left;border:1px solid #ddd;border-radius:4px;padding:6px 10px;">`;
			errors.forEach((err, i) => {
				html += `<div style="padding:5px 0;border-bottom:1px solid #eee;color:#dc3545;font-size:15px;font-weight:bold;">${i + 1}. ${err}</div>`;
			});
			html += `</div>`;
		}
		return html;
	}

	fileDataExists() {
		return !this.excelData;
	}

	isFormInvalid() {
		if (this.isExcelUpload) {
			return this.fileDataExists();
		} else {
			return !this.userdata.username ||
				   !this.userdata.password ||
				   !this.userdata.fullname ||
				   !this.userdata.mobile ||
				   !this.userdata.status ||
				   !this.userdata.branch_id ||
				   !this.userdata.doctor_id ||
				   !this.userdata.doctor_assistant ||
				   (this.branchCtrl.errors && this.branchCtrl.errors.required) ||
				   (this.branchCtrl.errors && this.branchCtrl.errors.inValidBranch) ||
				   (this.doctorlistCtrl.errors && this.doctorlistCtrl.errors.required);
		}
	}
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/doctorUserMaster/addEditDoctorUser.component.ts